import script from "./SettingsTermsAndConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsTermsAndConditions.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsTermsAndConditions.vue?vue&type=style&index=0&id=23e44b13&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e44b13"]])

export default __exports__